var arithmetic = require('./arithmetic.js');

module.exports = {
  match: function match(op) {
    return ['<<', '>>'].includes(op);
  },
  print: arithmetic.print
};